<template>
    <v-dialog v-model="showModal" max-width="500px" persistent>    
        <v-card flat>
            <v-toolbar dark class="primary">
            <v-btn icon @click.native="showModal = false" dark>
                <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title}}</v-toolbar-title>                    
            </v-toolbar>                 
            <v-card-text>
                <v-container  grid-list-xl>
                    <v-layout row wrap>   
                        <v-flex xs6>
                            <DatePicker v-model="holidayData.start" pickerLabel="Początek" :required="true" :readonly="false"></DatePicker>
                        </v-flex>                            
                        <v-flex xs6>
                            <DatePicker v-model="holidayData.end" pickerLabel="Koniec" :required="true" :readonly="false"></DatePicker>
                        </v-flex>                                            
                        <v-flex xs12>
                          <v-combobox
                            v-model="selectedType"
                            :items="types"
                            label="Wybierz typ urlopu"
                            item-text="text"                            
                          ></v-combobox>
                        </v-flex>                        
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="closeForm" color="error">Zamknij</v-btn>
                <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
            </v-card-actions>            
        </v-card>
    </v-dialog>
</template>

<script>
import { therapistsService } from "@/services/";
import swal from "sweetalert";

import DatePicker from "@/components/shared/DatePicker";
export default {
  name: "HolidayEdit",
  data() {
    return {
      title: "Dodawanie nowego urlopu",
      loading: false,
      types: [
        { text: "Wypoczynkowy", value: 0 },
        { text: "Na żądanie", value: 1 },
        { text: "Chorobowy", value: 2 }
      ],
      selectedType: null
    };
  },
  props: {
    visible: Boolean,
    holidayData: Object,
    therapistID: Number
  },
  computed: {
    showModal: {
      get: function() {
        if (!this.visible) {
          this.clearFormData();
          this.errors.clear();
        }
        return this.visible;
      },
      set: function(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },

  watch: {
    visible: function(newv) {
      if (newv) {
        if (this.holidayData.id == 0) {
          this.clearFormData();
          this.title = "Dodawanie nowego urlopu";
          this.selectedType = this.types.find(
            x => x.value == this.holidayData.type
          );
        } else {
          this.title = "Edycja urlopu";
          this.selectedType = this.types.find(
            x => x.value == this.holidayData.type
          );
        }
      }
    }
  },
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    updateFormData() {},
    clearFormData() {},
    closeForm() {
      this.$emit("close");
      this.clearFormData();
    },
    saveHoliday() {
      if (!this.holidayData.start) {
        this.showError(false, "Proszę podać datę początkową.");
        return;
      }
      if (!this.holidayData.end) {
        this.showError(false, "Proszę podać datę końcową.");
        return;
      }

      therapistsService
        .AddTherapistHoliday({
          start: this.holidayData.start,
          end: this.holidayData.end,
          type: this.selectedType.value,
          therapistID: this.therapistID
        })
        .then(success => {
          this.$emit("close");
          this.$emit("holidaySaved", success.data.result.items);
        })
        .catch(e => {
          if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
          ) {
            this.showError(false, e.response.data.error.message);
          } else {
            this.showError(false, "Błąd zapisu urlopu.");
          }
        });
    },
    updateHoliday() {
      therapistsService
        .UpdateTherapistHoliday({
          id: this.holidayData.id,
          start: this.holidayData.start,
          end: this.holidayData.end,
          type: this.selectedType.value
        })
        .then(() => {
          this.$emit("holidayUpdated", this.holidayData);
          this.$emit("close");
        })
        .catch(e => {
          if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
          ) {
            this.showError(false, e.response.data.error.message);
          } else {
            this.showError(false, "Błąd zapisu urlopu.");
          }
        });
    },
    handleSubmit() {
      if (this.holidayData.id == 0) {
        this.saveHoliday();
      } else {
        this.updateHoliday();
      }
    }
  },
  components: {
    DatePicker
  }
};
</script>

<style>
</style>
